var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckinline = function SvgCheckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 3.077a.835.835 0 0 1 0 1.18l-6.667 6.666a.834.834 0 0 1-1.18 0L1.412 7.59a.834.834 0 0 1 1.18-1.18l2.744 2.742 6.077-6.075a.835.835 0 0 1 1.18 0h-.003Z",
    fill: "#252525"
  })));
};
export default SvgCheckinline;